const TEMPLATE_NAME = 'NOTIFICATIONS';

const initialState = () => ({
    loading: false,
    data: [],
    filter: {
        term: '',
        data: [],
    },
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = action.payload;
            return {
                ...state,
                loading: false,
                data: data,
                filter: {
                    ...state.filter,
                    data,
                },
            };
        }
        // case `${TEMPLATE_NAME}_SEARCH`: {
        //     const term = action.payload;
        //     return {
        //         ...state,
        //         filter: {
        //             ...state.filter,
        //             term,
        //             data,
        //         },
        //     };
        // }
        case `${TEMPLATE_NAME}_UPDATE`: {
            const updatedRow = action.payload;
            const data = state.data.map(row => (row.id === updatedRow.id ? updatedRow : row));
            return {
                ...state,
                data,
                filter: {
                    ...state.filter,
                    data,
                },
            };
        }
        case `${TEMPLATE_NAME}_DELETE`: {
            const deletedId = action.payload;
            const data = state.data.filter(data => data.id !== deletedId);
            
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data,
                },
            };
        }
        case `${TEMPLATE_NAME}_CREATE`: {
            const newRow = action.payload;
            const data = [...state.data, newRow];
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data,
                },
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};

export default reducer;
